import { Appearance } from '../proto/user';

/** Remap appearance enum to css classes */
export const THEME_CLASSES = new Map<Appearance, string>([
  [
    Appearance.DEVICE,
    'theme-device',
  ],
  [
    Appearance.LIGHT,
    'theme-light',
  ],
  [
    Appearance.DARK,
    'theme-dark',
  ],
]);
